import script from "./TextEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./TextEditor.vue?vue&type=script&setup=true&lang=js"

import "./TextEditor.vue?vue&type=style&index=0&id=488e5b20&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-488e5b20"]])

export default __exports__